import useBookmarkSetter from '../../hooks/useBookmarkSetter';

const TiptapNodeBookmarkListnerPlugin = ({ id }:{ id: string }): null => {
  useBookmarkSetter(id);
  return null;
};

export default TiptapNodeBookmarkListnerPlugin;
